<template>
  <section></section>
</template>

<script>
export default {
  name: 'blog'
}
</script>

<style scoped>

</style>
